<template>
  <div class="my-page">
    <ul class="page-list">
      <!-- 上一页 -->
      <li
        :class="['page-list-item', currentPage <= 1 ? 'disbled' : '']"
        @click="handleBeforOrAfterClick('before')"
      >
        &lt;&lt;
      </li>
      <!-- 中间页码数据 -->
      <template v-for="(pageItem, index) in pageList">
        <!-- 向前5页 -->
        <li
          :class="['page-list-item', 'page-list-item-prev']"
          @click="handlePageItemClick(pageItem, 'prev')"
          :key="index"
          title="向前5页"
          v-if="pageItem == 'prev'"
          @mouseover="prevStatus = false"
          @mouseleave="prevStatus = true"
        >
          <i v-if="prevStatus"> ...</i>
          <!-- <i v-else>上一页</i> -->
        </li>
        <!-- 正常页码 -->
        <li
          :class="['page-list-item', 'page-list-item-next']"
          @click="handlePageItemClick(pageItem, 'next')"
          :key="index"
          title="向后5页"
          v-else-if="pageItem == 'next'"
          @mouseenter="nextStatus = false"
          @mouseleave="nextStatus = true"
        >
          <i v-if="nextStatus"> ...</i>
          <!-- <i v-else>下一页</i> -->
        </li>
        <!-- 向后五页 -->
        <li
          :class="['page-list-item', currentPage == pageItem ? 'active' : '']"
          @click="handlePageItemClick(pageItem)"
          :key="index"
          :title="pageItem"
          v-else
        >
          {{ pageItem }}
        </li>
      </template>
      <!-- 下一页 -->
      <li
        :class="[
          'page-list-item',
          currentPage >= totalPage && totalPage > 0 ? 'disbled' : '',
        ]"
        @click="handleBeforOrAfterClick('after')"
      >
        &gt;&gt;
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "fyPagination",
  props: {
    //总页码
    totalPage: {
      type: Number,
      default: 0,
    },
    // 当前页
    current: {
      type: Number,
      default: 1,
    },
    // 每页大小
    showSizer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 当前页码
      currentPage: this.current || 1,
      // 是否显示向后5条的>>
      prevStatus: true,
      // 是否显示向前5条的<<
      nextStatus: true,
    };
  },
  computed: {
    // 动态根据当前页,重新组装分页列表数据
    pageList() {
      //情况1： 总页码数<5的直接返回
      if (this.totalPage <= 5) {
        return this.totalPage;
      }
      //情况2： 总页码数>5页，当时当前页码数<=3
      if (this.currentPage <= 3) {
        return [1, 2, 3, "next", this.totalPage];
      }
      // 情况3：总页数-当前页数<=3
      if (this.currentPage > 3 && this.totalPage - this.currentPage <= 2) {
        return [
          1,
          "prev",
          this.totalPage - 2,
          this.totalPage - 1,
          this.totalPage,
        ];
      }
      // 情况4：排除其他的，剩下的就是有向前和向后的操作点
      return [
        1,
        "prev",
        this.currentPage - 2,
        this.currentPage - 1,
        this.currentPage,
        this.currentPage + 1,
        this.currentPage + 2,
        "next",
        this.totalPage,
      ];
    },
  },
  methods: {
    // 页码项点击
    handlePageItemClick(item, type) {
      // 重置向上和向下翻五页
      this.prevStatus = true;
      this.nextStatus = true;
      switch (type) {
        // 向前5页
        case "prev":
          this.currentPage -= 5;
          if (this.currentPage < 1) {
            this.currentPage = 1;
          }
          break;
        // 向后5页
        case "next":
          this.currentPage += 5;
          if (this.currentPage > this.totalPage) {
            this.currentPage = this.totalPage;
          }
          break;
        default:
          // 默认常规页码点击
          if (this.currentPage == item) {
            return;
          }
          this.currentPage = item;
      }
      // 发布页码变更事件
      this.$emit("on-change", this.currentPage);
    },
    // 上一页和下一页点击
    handleBeforOrAfterClick(type) {
      switch (type) {
        case "before":
          this.currentPage--;
          if (this.currentPage < 1) {
            this.currentPage = 1;
            return;
          }
          break;
        case "after":
          this.currentPage++;
          if (this.currentPage > this.totalPage) {
            this.currentPage = this.totalPage;
            return;
          }
          break;
      }
      // 发布页码变更事件
      this.$emit("on-change", this.currentPage);
    },
  },
};
</script>

<style>
.my-page {
  display: flex;
  justify-content: center;
  align-items: center;
}

.page-list {
  display: flex;
  justify-content: center;
  align-items: center;
}

.page-list-item {
  display: inline-block;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 2rem;
  height: 2rem;
  line-height: 1.875rem;
  list-style: none;
  text-align: center;
  cursor: pointer;
  color: #666;
  font-family: Arial;
  border: 1px solid #dcdee2;
  border-radius: .25rem;
  transition: all 0.2s ease-in-out;
  margin-right: .375rem;
  margin-left: .375rem;
}

.page-list-item:first-of-type,
.page-list-item:last-of-type {
  width: 3.75rem;
}

.page-list-item:hover {
  border-color: #020e62;
  color: #020e62;
}

.active.page-list-item {
  border-color: #020e62;
  color: #fff;
  background-color: #020e62;
}

.disbled.page-list-item {
  cursor: not-allowed;
  background-color: #fff;
  color: #dcdee2;
}

.disbled:hover {
  border-color: #dcdee2;
}
</style>
